/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'message': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs/><path pid="0" class="cls-1" d="M12.5 10.69V6.94A4.57 4.57 0 0 0 9.12 2.2V.56H6.88V2.2A4.55 4.55 0 0 0 3.5 6.94v3.75L2 12.19v.75h12v-.75zM8 15.5A1.5 1.5 0 0 0 9.5 14h-3A1.5 1.5 0 0 0 8 15.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/message.js